import SalesRegionMap from './SalesRegionMap';

export default SalesRegionMap;
